import React from "react";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import PrivateRoute from "../router/PrivateRoute";
import Header from "./common/Header";
import Main from "./modules/Inicio/pages/Main";
import LoginPage from "./modules/Acceso/pages/LoginPage";
import About from "./About";
import Contact from "./modules/Contacto/pages/Contact";
import PerfilPage from "./modules/Acceso/pages/PerfilPage";
import Footer from "./common/Footer";
import CategoriaPage from "./modules/Categoria/pages/CategoriaPage";
import ProductoPage from "./modules/Producto/pages/ProductoPage";
import CarritoPage from "./modules/Carrito/pages/CarritoPage.js";
import OrdenPage from "./modules/Carrito/pages/OrdenPage";
import RegistroPage from "./modules/Acceso/pages/RegistroPage";

export const Router = (props) => {
  const { history } = props;
  return (
    <ConnectedRouter history={history}>
      <div>
        <Header />
        <div className="contenido" style={{ minHeight: "70vh" }}>
          <Switch>
            <Route path="/" exact component={Main} />
            <Route path="/categoria/:categoria" component={CategoriaPage} />
            <Route path="/producto/:producto" component={ProductoPage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/registro" component={RegistroPage} />
            <Route path="/carrito" component={CarritoPage} />
            <Route path="/contact" component={Contact} />
            <PrivateRoute path="/perfil" component={PerfilPage} />
            <PrivateRoute path="/ordenes" component={OrdenPage} />
          </Switch>
        </div>
        <Footer />
      </div>
    </ConnectedRouter>
  );
};
